import { useContext } from "react";
import { UserContext } from "../../../../context";
import ExcelButton from "../../../../components/ExcelButton";
import { useGeneralAppStore } from "../../../../store/generalAppStore";
import { Spinner } from "react-bootstrap";

const FilterEstados = ({ estado, setEstado, filterFields, actasLocale }) => {

    const { actions } = useContext(UserContext);
    const loadKeys = [
        "asignar_notificador",
        "acta_detalle",
        "desasignar_notificador",
        "marcar_impresa",
        "notificadores",
    ];
    const { loads, handlerLoading } = useGeneralAppStore();

    const headers = [
        { label: "ID", key: "id" },
        { label: "Fecha hora", key: "fecha_hora" },
        { label: "#Acta", key: "numero_acta" },
        { label: "Fecha notificación", key: "fecha_notificacion" },
        { label: "Infraccion", key: "tipo" },
        { label: "Patente", key: "plate" },
        { label: "Localidad", key: "localidad" },
        { label: "Documento", key: "documento_titular" },
    ];

    const arrayEstados = [
        {
            estado_id: 3,
            estado: "Chequear",
            bg: '#6C757D',
            color: '#fff',
            role: ['admin.app', 'admin']
        },
        {
            estado_id: 7,
            estado: "Incompleta",
            bg: '#dc3545',
            color: '#fff',
            role: ['admin.app', 'admin']
        },
        {
            estado_id: 10,
            estado: "Aprobada",
            bg: '#0DCAF0',
            color: '#111',
            role: ['admin.app', 'admin']
        },
        {
            estado_id: 2,
            estado: "Impresa",
            bg: '#1134C9',
            color: '#fff',
            role: ['admin.app', 'admin']
        },
        {
            estado_id: 8,
            estado: "Reparto",
            bg: '#FFC107',
            color: '#111',
            role: ['admin.app', 'admin']
        },
        {
            estado_id: 9,
            estado: "Sin Entregar",
            bg: '#FFC107',
            color: '#111',
            role: ['admin.app', 'admin']
        },
        {
            estado_id: 4,
            estado: "Notificada",
            bg: '#198754',
            color: '#fff',
            role: ['admin.app', 'tribunales', 'admin']
        },
        {
            estado_id: 11,
            estado: "Abonada",
            bg: '#198754',
            color: '#fff',
            role: ['admin.app', 'tribunales', 'admin']
        },
        {
            estado_id: 13,
            estado: "Descargo",
            bg: '#111',
            color: '#fff',
            role: ['admin.app', 'tribunales', 'admin']
        },
        {
            estado_id: 15,
            estado: "Tribunales",
            bg: '#111',
            color: '#fff',
            role: ['tribunales', 'admin']
        },
        {
            estado_id: 17,
            estado: "Doble",
            bg: '#dc3545',
            color: '#fff',
            role: ['admin.app', 'admin']
        },
        {
            estado_id: 18,
            estado: "Anuladas",
            bg: '#dc3545',
            color: '#fff',
            // role: ['admin.app', 'admin']
            role: ['admin']
        },
        {
            estado_id: 19,
            estado: "Dictaminadas",
            bg: '#7B1FA2',
            color: '#fff',
            // role: ['admin.app', 'admin']
            role: ['admin', 'tribunales']
        }
    ]

    const estadosPermitidos = arrayEstados.filter(est =>
        est.role.some(r => actions.hasRole(r))
    );


    return (
        <section className="my-4 d-flex justify-content-around align-items-center">
            <div className="d-flex gap-3 align-items-center flex-wrap ">
                {
                    estadosPermitidos.map(est => (
                        <div key={est.estado_id} style={{ background: est?.bg, color: est?.color, cursor: !loads?.includes('get_actas') ? "pointer" : "no-drop" }} onClick={() => {
                            {
                                handlerLoading({ loading: true, loadName: "get_actas" })
                                setEstado(est?.estado_id)
                            }
                            // if (!loads?.includes('get_actas')) {
                            //     setEstado(est?.estado_id)
                            // }
                        }}
                            className="rounded px-2 fw-semibold position-relative"  >

                            {
                                estado != est?.estado_id &&
                                <div className="position-absolute top-0 w-100 h-100 " style={{ background: '#fff', left: "0", opacity: "70%" }}></div>
                            }
                            {est.estado}
                        </div>
                    ))
                }
            </div>
            <div className=" d-flex  align-items-center gap-4 " style={{ width: "fit-content" }}>
                <div className="d-flex align-items-center " >
                    <ExcelButton headers={headers} filename={"listado-actas.csv"} estados={[estado]} filterFields={filterFields} actasLocale={actasLocale} />
                </div>
            </div>
        </section >
    )
}

export default FilterEstados;